angular.module('pitch.app')

.factory('Content', function(config, $resource, Locale) {
    return $resource(config.apiUri + '/contents/:id', {
        // lang: Locale.get()
    });
})

.factory('ContentLoader', function(Content, $q) {
    return function(params) {
        var delay = $q.defer();

        Content.get(params, function(resp) {
            if (resp.type === 'reference' &&
                !resp.subject
            ) {
                delay.reject('Fetched partial Content');
            } else {
                delay.resolve(resp);
            }
        }, function() {
            delay.reject('Unable to fetch Content');
        });

        return delay.promise;
    };
})

.factory('ContentsLoader', function(Content, LoaderFactory) {
    return function(params) {
        return new LoaderFactory(Content, params);
    };
})

//ContextContentsLoader first determines the context in which the site is
//viewed and then loads content based on the context
.factory('ContextContentsLoader', function(Content, SiteContext, $q) {
    return function(paramFn) {
        var delay = $q.defer();

        function loadContent(r) {
            Content.query(paramFn(r), function(resp) {
                delay.resolve(resp);
            }, function() {
                delay.reject('Unable to fetch Contents');
            });
        }

        SiteContext.get().then(loadContent, loadContent);

        return delay.promise;
    };
})

// .factory('TopTracks', function(config, $resource) {
//     return $resource(config.apiUri + '/content/songwriters/:songWriterId/toptracks');
// })

;



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/services/Content.js